<template>
  <div class="confirm-step">
    <p class="confirm-step__summary">
      {{ pluralize(store.previewData.summary.valid, store.config.label.toLowerCase()) }} will be added
      <span v-if="store.sendInvites"> and invited</span>.
      <span v-if="store.previewData.summary.existing > 0">
        {{ store.previewData.summary.existing }} already registered.
      </span>
      <span v-if="store.previewData.summary.errors > 0"> {{ store.previewData.summary.errors }} with errors. </span>
    </p>

    <ul v-if="hasPreviewErrors" class="confirm-step__warning">
      <li v-for="(error, index) in store.previewData.errors" :key="index">{{ error }}</li>
    </ul>

    <PreviewTable
      :headers="store.previewData.headers"
      :rows="store.previewData.rows"
      :selected-keys="store.selectedRowKeys"
      :all-selected="store.allRowsSelected"
      :indeterminate="store.selectionIndeterminate"
      :selection-labels="store.labels.selection"
      @toggle-row="store.toggleRow"
      @toggle-all="store.toggleAllRows"
    />

    <div class="confirm-step__error">
      {{ store.errorMessage }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import PreviewTable from "./PreviewTable.ce.vue";
import { useRsvpInviteStore } from "#ce/apps/SpAdmin/SpRsvpInviteApp/store/rsvpInvite";
import { pluralize } from "#ce/apps/SpAdmin/SpRsvpInviteApp/utils/emailParser";

const store = useRsvpInviteStore();

const hasPreviewErrors = computed(() => store.previewData.errors.length > 0 || store.previewData.summary.errors > 0);
</script>

<style scoped lang="scss">
.confirm-step {
  display: flex;
  flex-direction: column;
  gap: var(--sp-ref-scale-16);

  &__summary {
    font-size: var(--sp-sys-typescale-body-font-size, 1rem);
    margin: 0;
  }

  &__warning {
    color: var(--sp-sys-color-warning, #f57c00);
    font-size: var(--sp-sys-typescale-small-font-size, 0.875rem);
    margin: 0;
  }

  &__error {
    color: var(--sp-sys-color-error, #d32f2f);
    font-size: var(--sp-sys-typescale-small-font-size, 0.875rem);
    min-height: 1.25rem;
  }
}
</style>
